/*
*###############################################################################
*Module Name                   : BillOfMeterialContent.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 15h 2022, 10:14:01 am          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import DPAlert from 'framework/widgets/DPAlert'
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import ReactPaginate from 'react-paginate';


const BillOfMeterialContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,

    menuCode,
    dbCazeSize,
    tog_xlargePro,
    modalXlargeProduct,
    DataRow,
    totalCost,
    proCode,
    SetTotalCost,
    SetSize,
    GetSelectRowProduct,
    autoCode,
    dbCazeSizeonBlur,
    proDescription,
    setarRow,
    SetProCode,
    SetProDescription,
    finishProductCode,
    finishProductDesc,
    tog_xlarge_finishpro,
    model_xlarge_finishpro,
    GetSelectRowFinishProduct,
    addNew,
    finishProductCodeOnBlur,
    finishProductCodeOnChange,
    LocationCode,
    currentPage,
    setCurrentPage
}) => {

    const [groupFilter, SetGroupFilter] = useState('a')
    const ApiURL = window.Links.ApiURL
    const [postsPerPage] = useState(10)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    async function tog_backdrop() {
        modelTrigger();
    }

    async function tog_backdropPro() {
        tog_xlargePro();
    }

    const defaultSorted = [{
        dataField: 'BOM_CODE',
        order: 'asc'
    }];


    useEffect(() => {
        if (currentPosts.length == 0 && DataRow.length > 0) {
            setCurrentPage(prev => prev - 1)
        }
    }, [currentPosts])

    /**
        * @description This function is used to change the value of perticular field in perticular row.
        * @param {string} value - value of the row.
        * @param {string} id - id of the row.
        * @param {string} element - element of the row.
     */

    const changeRowValueChanges = (value, id, element) => {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        const newObject = { ...DataRow[objectIndex], [element]: value };
        setarRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };

    /**
        * @description This function is used to change the value of complete row.
        * @param {JSON} row - row of the table.
        * @param {string} id - id of the row.
     */

    function handleObjectChange(row, id) {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        setarRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = row;
            return newDataRow;
        });
    }


    function handleAddRowNested() {
        const modifiedRows = [...DataRow];

        const hasEmptyRow = modifiedRows.find(x => x.Subcode === "");

        if (hasEmptyRow) {
            return false;
        }

        modifiedRows.push({
            id: 1,
            Subcode: "",
            subDesc: "",
            subCost: 0,
            caseSize: 0,
            Unit: "",
            UnitName: "",
            qty: 1,
            amount: 0,
            baseProduct: false,
            isDecimal: 1,
            unitSize:0

        });

        const idModification = modifiedRows.map((item, index) => {
            item.id = index + 1;
            return item
        })

        setarRow(idModification);

        setCurrentPage(Math.ceil(idModification.length / postsPerPage))




    }


    function handleRemoveRow(id) {

        const modifiedRows = [...DataRow]
        const index = modifiedRows.findIndex(row => row.id === id)

        if (modifiedRows[index].baseProduct == true) {
            SetProCode("")
            SetProDescription("")
        }

        modifiedRows.splice(index, 1)

        if (modifiedRows.length == 0) {
            modifiedRows.push({
                id: 1,
                Subcode: "",
                subDesc: "",
                subCost: 0,
                caseSize: 0,
                Unit: "",
                UnitName: "",
                qty: 1,
                amount: 0,
                baseProduct: false,
                isDecimal: 1,
                unitSize : 0
            })
        }

        const idModification = modifiedRows.map((item, index) => {
            item.id = index + 1;
            return item
        })

        setarRow(idModification)

        var total = 0;
        modifiedRows.forEach((row) => {
            if (row.Subcode != "") {
                total = parseFloat(parseFloat(total) + ((parseFloat(row.subCost) / parseFloat(row.caseSize)) * parseFloat(row.qty))).toFixed(3)
            }
        })

        SetTotalCost(parseFloat(parseFloat(total) / parseFloat(dbCazeSize)).toFixed(3))
    }

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code *"
                                    textType="text"
                                    maxLength="5"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled == true ? disabled : disabledCode}
                                    onButtonClick={onButtonClick}
                                    btnDisable={disabled == true ? disabled : btnDisable}
                                    placeholder={autoCode}

                                />


                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>


                        </Row>
                        <Row>
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Name Of BOM *"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled}
                                />
                            </Col>
                        </Row>
                        <Row >
                            <Col sm={12} md={6} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Finish Product
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={3} className="mb-4-sm" >
                                        <DPTextBoxforgrid
                                            rowClass="mb-12-sm"
                                            disabled={!addNew ? true : DataRow.some(x => x.Subcode != "") ? true : false}
                                            textType="text"
                                            textAlign="left"
                                            value={finishProductCode}
                                            onChange={finishProductCodeOnChange}
                                            onBlur={finishProductCodeOnBlur}
                                        />
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                tog_xlarge_finishpro()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={!addNew ? true : DataRow.some(x => x.Subcode != "") ? true : false}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                    <Col sm={12} md={5} className="mb-4-sm">
                                        <DPTextBoxforgrid
                                            rowClass="mb-12-sm"
                                            disabled="true"
                                            textType="text"
                                            textAlign="left"
                                            value={finishProductDesc}
                                        />
                                    </Col>

                                </Row>

                            </Col>

                        </Row>
                        <Row >
                            <Col sm={12} md={6} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Base Product
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={3} className="mb-4-sm" style={{ paddingRight: 0 }} >
                                        <DPTextBoxforgrid
                                            rowClass="mb-12-sm"
                                            disabled="true"
                                            textType="text"
                                            textAlign="left"
                                            value={proCode}
                                        />
                                    </Col>
                                    <Col sm={12} md={6} className="mb-4-sm" style={{ paddingLeft: 0 }}>
                                        <DPTextBoxforgrid
                                            rowClass="mb-12-sm"
                                            disabled="true"
                                            textType="text"
                                            textAlign="left"
                                            value={proDescription}
                                        />
                                    </Col>

                                </Row>

                            </Col>

                        </Row>


                        <Row>
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="BOM Size"
                                    textType="text"
                                    textAlign="right"
                                    value={dbCazeSize}
                                    onChange={SetSize}
                                    onBlur={dbCazeSizeonBlur}
                                    disabled={disabled}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Calculated Cost"
                                    textType="text"
                                    textAlign="right"
                                    value={parseFloat(totalCost).toLocaleString('en-US', {
                                        minimumFractionDigits: 3,
                                        maximumFractionDigits: 3,
                                    })}
                                    disabled={true}
                                />
                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-5 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>


                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12} md={12} className="mb-4-sm">
                                <table style={{ fontSize: "11px" }} id={"BillofMetirial"} >
                                    <thead className="table-light">
                                        <tr>
                                            <th>No</th>
                                            <th>Sub Product Code</th>
                                            <th></th>
                                            <th>Sub Product Name</th>
                                            <th>Cost Price</th>
                                            <th>Case Size</th>
                                            <th>Unit of Measure</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                            <th style={{ textAlign: 'center' }}>Base Product</th>
                                        </tr>
                                    </thead>
                                    <tbody disabled={true}>
                                        {currentPosts.map((formRow, key) => (
                                            <TableRow
                                                FormRow={formRow}
                                                Key={key}
                                                RemoveRow={handleRemoveRow}
                                                Disabled={disabled}
                                                menuCode={menuCode}
                                                proCode={proCode}
                                                SetTotalCost={SetTotalCost}
                                                totalCost={totalCost}
                                                dbCazeSize={dbCazeSize}
                                                changeRowValueChanges={changeRowValueChanges}
                                                handleObjectChange={handleObjectChange}
                                                DataRow={DataRow}
                                                SetProCode={SetProCode}
                                                SetProDescription={SetProDescription}
                                                LocationCode={LocationCode}
                                                finishProductCode={finishProductCode}
                                                indexOfFirstPost={indexOfFirstPost}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                                <Row sm={12} md={12} className="mb-4-sm mt-2">
                                    <Col>
                                        <Button
                                            disabled={disabled}
                                            onClick={() => {
                                                handleAddRowNested()
                                            }}
                                            color="success"
                                            className="mt-1"
                                            size='sm'
                                        >
                                            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                                        </Button>
                                    </Col>
                                    <Col className='mt-2'>
                                        <ReactPaginate
                                            previousLabel={'Previous'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            pageCount={Math.ceil(DataRow.length / postsPerPage)}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            forcePage={currentPage - 1}
                                            renderOnZeroPageCount={null}
                                            activeClassName={'active'}
                                            activeLinkClassName={'page-link'}
                                            containerClassName={'pagination justify-content-end pagination-sm'}
                                        />
                                    </Col>
                                </Row>
                            </Col>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"BOM"}
                                MenuCode={menuCode}
                                KeyVal={'BOM'}
                                searchBy={'BOM_CODE'}
                                FilterStr={groupFilter}
                            />
                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={"Product Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modalXlargeProduct}
                                toggle={tog_xlargePro}
                                getSelect={GetSelectRowProduct}
                                APIURL={ApiURL}
                                URLPath={"PRODUCT"}
                                MenuCode={menuCode}
                                KeyVal={'BOM'}
                                searchBy={'PLU_CODE'}
                                FilterStr={groupFilter}
                            />

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={"Product Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={model_xlarge_finishpro}
                                toggle={tog_xlarge_finishpro}
                                getSelect={GetSelectRowFinishProduct}
                                APIURL={ApiURL}
                                URLPath={"FINISHPRODUCT"}
                                MenuCode={menuCode}
                                KeyVal={'PRO'}
                                searchBy={'PLU_CODE'}
                                FilterStr={groupFilter}
                            />

                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}


export default BillOfMeterialContent


const TableRow = ({ FormRow, Key, RemoveRow, Disabled, proCode,
    menuCode, SetTotalCost, totalCost, dbCazeSize, changeRowValueChanges,
    handleObjectChange, DataRow, indexOfFirstPost,
    SetProDescription, SetProCode, LocationCode, finishProductCode
}) => {
    const ApiURL = window.Links.ApiURL

    const [modal_xlargesub, setmodal_xlargesub] = useState(false)
    const [Datatablesub, SetDatatablesub] = useState([])
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)


    const [groupFilter, SetGroupFilter] = useState('a')

    //**Set the Default sort column and Sort order*/
    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]
    //********************************************/


    const Hed_SelectRowSearchsup = (e, row, isSelect, rowIndex) => {

        if (CodeValidationSup(row.PLU_CODE, "txtsubcode" + Key)) {
            getsubData(row.PLU_CODE)
        } else {
            setAlertDescription("Can not Add sub Product more than one time !")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            var currentRow = FormRow
            currentRow.Subcode = ""
            currentRow.subDesc = ""
            handleObjectChange(currentRow, FormRow.id)
        }

        setmodal_xlargesub(!modal_xlargesub)

    }


    function getsubData(searchdata) {

        if (searchdata != "") {
            const authToken = localStorage.getItem("authToken")
            const ApiURL = window.Links.ApiURL
            fetch(`${ApiURL}Product/search_location/${searchdata}/${LocationCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
            }).then(Response => Response.json())
                .then(responseData => {
                    if (responseData.success == true) {
                        const newArray = responseData.data[0]
                        var currentRow = FormRow
                        currentRow.Subcode = newArray.strProductCode
                        currentRow.subDesc = newArray.strProductDesc
                        currentRow.subCost = parseFloat(newArray.dbCost).toFixed(3)
                        currentRow.caseSize = newArray.dbCaseSize
                        currentRow.UnitName = newArray.strUnitDesc
                        currentRow.Unit = newArray.strUnit
                        //currentRow.isDecimal = newArray.isDecimal  2024.05.21 - Dinisuru requested by Sachithra to remove decimal validation
                        currentRow.isDecimal = 1
                        currentRow.amount = parseFloat((parseFloat(newArray.dbCost) / parseFloat(newArray.dbCaseSize)) * parseFloat(currentRow.qty)).toFixed(3)
                        currentRow.isDisabled = true
                        currentRow.unitSize = newArray.dbUnitSize
                        handleObjectChange(currentRow, FormRow.id)

                        var currElement = document.getElementById("qty" + Key)
                        if (currElement != null) {
                            currElement.focus()
                        }

                        setTimeout(() => {
                            CalculateTotal()
                        }, 100)

                    } else {
                        setAlertDescription(responseData.msg)
                        setAlertConfirmOption(4)
                        setsweetAlertShow(true)
                        var currentRow = FormRow
                        currentRow.Subcode = ""
                        currentRow.subDesc = ""
                        handleObjectChange(currentRow, FormRow.id)
                    }
                }).catch(error => {
                    console.log(error)
                    alert("Product Not Found !")
                    setAlertDescription("Product Not Found !")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    changeRowValueChanges("", FormRow.id, "Subcode")
                })
        } else {
            var currentRow = FormRow
            currentRow.Subcode = ""
            currentRow.subDesc = ""
            currentRow.subCost = 0
            currentRow.caseSize = 0
            currentRow.UnitName = ""
            currentRow.Unit = ""
            currentRow.qty = 0
            currentRow.amount = 0
            currentRow.unitSize = 0
            handleObjectChange(currentRow, FormRow.id)
        }

        setTimeout(() => {
            CalculateTotal()
        }, 100)
    }

    function tog_xlargesub() {
        setmodal_xlargesub(!modal_xlargesub)
        removeBodyCss()
    }


    async function clicksubSearch() {

        if (finishProductCode == "") {
            setAlertDescription("Please Select Finish Product !")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            return
        }

        tog_xlargesub();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    const CodeValidationSup = (code, id) => {

        const filterByCode = DataRow.filter(x => x.Subcode == code && x.id != FormRow.id)

        if (filterByCode.length > 0) {
            return false
        }

        return true
    }

    const CalculateTotal = () => {
        var total = 0;

        DataRow.forEach((row) => {
            if (row.Subcode != "") {
                total = parseFloat(parseFloat(total) + ((parseFloat(row.subCost) / parseFloat(row.caseSize)) * parseFloat(row.qty))).toFixed(3)
            }
        })

        SetTotalCost(parseFloat(parseFloat(total) / parseFloat(dbCazeSize)).toFixed(3))

    }

    return (
        <tr key={FormRow.id}>
            <td style={{ width: "40px" }}>
                {indexOfFirstPost + Key + 1}
            </td>
            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled={Disabled ? true : FormRow.isDisabled}
                            labelText="subCode"
                            textType="text"
                            maxLength="25"
                            id={"txtsubcode" + Key}
                            value={FormRow.Subcode}
                            onChange={(e) => {
                                var value1 = Text(e.target, 25, true, false, "upper", false)
                                changeRowValueChanges(value1, FormRow.id, "Subcode")
                            }}
                            onBlur={e => {

                                if (finishProductCode == "") {
                                    setAlertDescription("Please Select Finish Product !")
                                    setAlertConfirmOption(4)
                                    setsweetAlertShow(true)
                                    changeRowValueChanges("", FormRow.id, "Subcode")
                                    return
                                }

                                if (CodeValidationSup(e.target.value, "txtsubcode" + Key)) {
                                    getsubData(e.target.value)
                                } else {
                                    setAlertDescription("Can not Add sub Product more than one time !")
                                    setAlertConfirmOption(4)
                                    setsweetAlertShow(true)

                                    var currentRow = FormRow
                                    currentRow.Subcode = ""
                                    currentRow.Unit = ""
                                    handleObjectChange(currentRow, FormRow.id)

                                }
                            }}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td>
                <Row className="mb-0">
                    <Col md="12">
                        <Button
                            outline
                            disabled={Disabled ? true : FormRow.isDisabled}
                            color="success"
                            id={"btnsubSearch" + Key}
                            onClick={clicksubSearch}
                            size="sm">
                            <i
                                className="mdi mdi-search-web"
                                style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "300px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled="true"
                            labelText="subdesc"
                            textType="text"
                            textAlign="left"
                            id={"subdesc" + Key}
                            value={FormRow.subDesc}

                            onChange={(e) => {
                                var val1 = Text(e.target, 20, true, true, "any", false)

                                // setUnit(val1)
                            }}
                            onBlur={e => {

                                // getunit(e.target.value)

                            }}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled="true"
                            labelText="subCost"
                            textType="text"
                            textAlign="right"
                            id={"subCost" + Key}
                            value={parseFloat(FormRow.subCost).toLocaleString('en-US', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                            })}
                            onChange={(e) => {
                                var val1 = Text(e.target, 20, true, true, "any", false)
                            }}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled="true"
                            labelText="caseSize"
                            textType="text"
                            textAlign="right"
                            id={"caseSize" + Key}
                            value={FormRow.caseSize}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled="true"
                            labelText="unit"
                            textType="text"
                            textAlign="left"
                            id={"unitname" + Key}
                            value={FormRow.UnitName}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>

            <td style={{ width: "100px", display: 'none' }} >
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled={Disabled}
                            labelText="unit"
                            textType="text"
                            textAlign="right"
                            id={"unit" + Key}
                            value={FormRow.Unit}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>

            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled={Disabled}
                            labelText="qty"
                            textType="text"
                            textAlign="right"
                            id={"qty" + Key}
                            value={FormRow.qty}
                            onChange={(e) => {
                                var val2 = 0;

                                if (FormRow.isDecimal == 1) {
                                    val2 = Numeric(e.target, 8, 3, false)
                                } else {
                                    val2 = Numeric(e.target, 8, 0, false)
                                }

                                changeRowValueChanges(val2, FormRow.id, "qty")

                            }}
                            onBlur={(e) => {
                                var val2 = 0;

                                if (FormRow.isDecimal == 1) {
                                    val2 = DecimalValidation(e.target.value, 0, true, 3)
                                } else {
                                    val2 = DecimalValidation(e.target.value, 0, false, 3)
                                }

                                if (val2 != 0) {

                                    var currentRow = FormRow
                                    currentRow.qty = val2
                                    currentRow.amount = parseFloat(parseFloat(val2) * (parseFloat(currentRow.subCost) / parseFloat(currentRow.caseSize))).toFixed(3)
                                    handleObjectChange(currentRow, FormRow.id)
                                    // Setamount(parseFloat(parseFloat(val2, 10) * parseFloat(subCost)).toFixed(3))
                                }
                                else {
                                    var currentRow = FormRow
                                    currentRow.qty = 1
                                    currentRow.amount = parseFloat(parseFloat(1) * (parseFloat(currentRow.subCost) / parseFloat(currentRow.caseSize))).toFixed(3)
                                    handleObjectChange(currentRow, FormRow.id)
                                }

                                setTimeout(() => {
                                    CalculateTotal()
                                }, 100)

                            }}
                            onKeyPress={(e) => {


                                if (e.key === 'Enter') {
                                    var val2 = 0;

                                    if (FormRow.isDecimal == 1) {
                                        val2 = DecimalValidation(e.target.value, 0, true, 3)
                                    } else {
                                        val2 = DecimalValidation(e.target.value, 0, true, 3)
                                    }

                                    if (val2 != 0) {
                                        var currentRow = FormRow
                                        currentRow.qty = val2
                                        currentRow.amount = parseFloat(parseFloat(val2) * (parseFloat(currentRow.subCost) / parseFloat(currentRow.caseSize))).toFixed(3)
                                        handleObjectChange(currentRow, FormRow.id)
                                    }
                                    else {
                                        var currentRow = FormRow
                                        currentRow.qty = 1
                                        currentRow.amount = parseFloat(parseFloat(1) * (parseFloat(currentRow.subCost) / parseFloat(currentRow.caseSize))).toFixed(3)
                                        handleObjectChange(currentRow, FormRow.id)
                                    }

                                    setTimeout(() => {
                                        CalculateTotal()
                                    }, 100)
                                }
                            }}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "100px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            disabled={true}
                            labelText="amount"
                            textType="text"
                            textAlign="right"
                            id={"amount" + Key}
                            value={parseFloat(FormRow.amount).toLocaleString('en-US', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                            })}
                            onChange={(e) => {
                                var val2 = 0

                                if (FormRow.isDecimal == 1) {
                                    val2 = Numeric(e.target, 8, 3, false)
                                } else {
                                    val2 = Numeric(e.target, 8, 0, false)
                                }

                                changeRowValueChanges(val2, FormRow.id, "amount")
                            }}
                            onBlur={(e) => {
                                var val2 = Numeric(e.target, 8, 2, false)
                                changeRowValueChanges(parseFloat(val2).toFixed(2), FormRow.id, "amount")
                                // Setamount(parseFloat(val2).toFixed(2))
                            }}
                            backgroundColor={FormRow.baseProduct}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>

            <td style={{ width: "90px", margin: "auto" }}>
                <Row className="mb-0">
                    <Col md="12" style={{ textAlign: "center" }}>
                        <DPSwitch
                            id={"baseProduct" + Key}
                            checked={FormRow.baseProduct}
                            disabled={Disabled ? true : DataRow.some((x) => x.baseProduct === true) && FormRow.baseProduct == false ? true : false}
                            onChange={e => {
                                changeRowValueChanges(e, FormRow.id, "baseProduct")
                                if (e) {
                                    SetProDescription(FormRow.subDesc)
                                    SetProCode(FormRow.Subcode)
                                } else {
                                    SetProDescription("")
                                    SetProCode("")
                                }
                            }}
                        />
                    </Col>
                </Row>
            </td>

            <td>
                <Row className="mb-0">
                    <Col md="1">
                        <Button
                            outline
                            disabled={Disabled}
                            color="danger"
                            id={"btnDelete" + Key}
                            onClick={e => {
                                RemoveRow(FormRow.id)
                            }}
                            size="sm">
                            <i
                                className="mdi mdi-delete"
                                style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                    </Col>{" "}


                    <DPSearchBoxDynamic
                        searchData={Datatablesub}
                        columns={[]}
                        defaultSorted={defaultSorted}
                        mainTitle={"Sub Product Search"}
                        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                        isOpen={modal_xlargesub}
                        toggle={tog_xlargesub}
                        getSelect={Hed_SelectRowSearchsup}
                        APIURL={ApiURL}
                        URLPath={"SUBPRODUCT"}
                        MenuCode={menuCode}
                        KeyVal={'BOM'}
                        searchBy={'PLU_CODE'}
                        FilterStr={groupFilter}
                    />

                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={"Product Master !"}
                        description={AlertDescription}
                        showCancel={false}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            setsweetAlertShow(false)

                        }}
                        btnYes={"OK"}
                    />
                </Row>
            </td>
        </tr>
    )
}